import React, { useEffect, useState } from "react";
import { Grid, Typography, Box, IconButton, Divider } from "@mui/material";
import {
  Facebook,
  Instagram,
  LocationOn,
  Phone,
  Email,
} from "@mui/icons-material";
import { Twitter, YouTube, WhatsApp } from "@mui/icons-material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Link } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "../stylesheets/Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <Box
      component="footer"
      sx={{ backgroundColor: "#000000", py: 4, color: "#fff" }}
    >
      <Box sx={{ ml: { md: 10, xs: 3 }, mr: { md: 10, xs: 3 } }}>
        <Grid container spacing={4}>
          {/*  Useful Links Section */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              style={{
                fontWeight: "600",
                fontFamily: "Montserrat, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
              }}
            >
              Useful Links
            </Typography>
            <Box mb={2} />
            <Box display="flex" flexDirection="column" gap={2}>
              <Link
                to="/"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Home
              </Link>
              <Link
                to="/about-school"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                About
              </Link>
              <Link
                to="/director-message"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Director Message
              </Link>
              <Link
                to="/admission-process"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Admission Process
              </Link>
              <Link
                to="/online-fees"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Online Fees
              </Link>

              <Link
                to="/activities"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Activities
              </Link>

              <Link
                to="/academic-calendar"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Academic Calendar
              </Link>
              <Link
                to="/hostel-facility"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Hostel Facility
              </Link>
            </Box>
          </Grid>

          {/* School Programs Section */}

          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              style={{
                fontWeight: "600",
                fontFamily: "Montserrat, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
              }}
            >
              School Programs
            </Typography>
            <Box mb={2} />
            <Box display="flex" flexDirection="column" gap={2}>
              <Link
                to="/navodaya"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Navodaya
              </Link>
              <Link
                to="/RIMC"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                RIMC
              </Link>
              <Link
                to="/sainik"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Sainik
              </Link>
              <Link
                to="/military"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Military
              </Link>
            </Box>
          </Grid>

          {/* More Section */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              style={{
                fontWeight: "600",
                fontFamily: "Montserrat, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
              }}
            >
              More
            </Typography>
            <Box mb={2} />
            <Box display="flex" flexDirection="column" gap={2}>
              <Link
                to="/news-events"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                News & Events
              </Link>
              <Link
                to="/gallery"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Gallery
              </Link>
              <Link
                to="/contact"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Contact
              </Link>
              <Link
                to="/privacy-policy"
                className="footer-link"
                style={{ display: "flex", alignItems: "center" }}
              >
                <ChevronRightIcon
                  fontSize="small"
                  style={{
                    marginRight: 4,
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                  }}
                />
                Privacy Policy
              </Link>
            </Box>
          </Grid>

          {/* Let's Connect Section */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              gutterBottom
              style={{
                fontWeight: "600",
                fontFamily: "Montserrat, sans-serif",
                fontOpticalSizing: "auto",
                fontStyle: "normal",
              }}
            >
              Let's Connect
            </Typography>
            <Box mb={2} />

            <Box display="flex" alignItems="center" gap={1.5} mt={2}>
              <LocationOn
                sx={{
                  color: "#fff",
                  backgroundColor: "#AD1C86",
                  borderRadius: "50%",
                  fontSize: "35px",
                  p: 1,
                }}
              />
              <Typography
                component="a"
                href="https://www.google.com/maps/place/Shree+Mangalam+School+%2Facademy+gudha/@27.8665696,75.516023,15z/data=!4m6!3m5!1s0x396ccd605d059b21:0xfeb4cb05a7d17e91!8m2!3d27.8597019!4d75.5100027!16s%2Fg%2F11c3ss2s1_?entry=ttu&g_ep=EgoyMDI1MTIwOS4wIKXMDSoKLDEwMDc5MjA2OUgBUAM%3D"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  color: "#fff",
                  textDecoration: "none",
                  cursor: "pointer",
                  // "&:hover": { textDecoration: "underline" },
                }}
              >
                Jaipur-Gudha State Highway (Just on by pass) In Gudha Gorji Raj.
                pin 333022
              </Typography>
            </Box>

            <Box display="flex" alignItems="center" gap={1.5} mt={2}>
              <Phone
                sx={{
                  color: "#fff",
                  backgroundColor: "#AD1C86",
                  borderRadius: "50%",
                  fontSize: "35px",
                  p: 1,
                }}
              />
              <Typography
                component="a"
                href="tel:+919928263305"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  color: "#fff",
                  textDecoration: "none",
                  cursor: "pointer",
                  // "&:hover": { textDecoration: "underline" },
                }}
              >
                +919928263305
              </Typography>
            </Box>

            <Box display="flex" alignItems="center" gap={1.5} mt={2}>
              <Phone
                sx={{
                  color: "#fff",
                  backgroundColor: "#AD1C86",
                  borderRadius: "50%",
                  fontSize: { xs: "35px", md: "35px" },
                  p: 1,
                }}
              />
              <Typography
                component="a"
                href="tel:+919413645511"
                sx={{
                  fontFamily: "Montserrat, sans-serif",
                  color: "#fff",
                  textDecoration: "none",
                  cursor: "pointer",
                  // "&:hover": { textDecoration: "underline" },
                }}
              >
                +919413645511
              </Typography>
            </Box>

            <Box
              display="flex"
              alignItems="center"
              gap={1.5}
              mt={2}
              flexWrap={{ xs: "wrap", md: "nowrap" }}
            >
              <Email
                sx={{
                  color: "#fff",
                  backgroundColor: "#AD1C86",
                  borderRadius: "50%",
                  p: 1,
                  fontSize: "35px",
                  flexShrink: 0,
                }}
              />
              <Typography
                component="div"
                sx={{
                  fontSize: "11px",
                  color: "#fff",
                  wordBreak: "break-word",
                }}
              >
                <a
                  href="mailto:shreemangalamacademy11@gmail.com"
                  className="footer-link"
                  style={{
                    fontFamily: "Montserrat, sans-serif",
                    fontOpticalSizing: "auto",
                    fontStyle: "normal",
                    color: "inherit",
                    textDecoration: "none",
                    fontSize: "15px",
                  }}
                >
                  shreemangalamacademy11@gmail.com
                </a>
              </Typography>
            </Box>

            <Box mt={5}>
              {/* WhatsApp Channel */}
              {/* <IconButton
                href="https://whatsapp.com/channel/0029Vb9t3Ks545ulxNoHQY37"
                target="_blank"
                sx={{
                  color: "#fff",
                  backgroundColor: "#AD1C86",
                  mr: 2,
                  "&:hover": {
                    backgroundColor: "#065A79",
                  },
                }}
                aria-label="Join our WhatsApp channel"
              >
                <WhatsApp sx={{ fontSize: { xs: "30px", md: "25px" } }} />
              </IconButton> */}

              <IconButton
                component="a"
                // href="https://wa.me/919928263305"
                href="https://wa.me/919928263305?text=Hello%20I%20want%20admission%20details"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "#fff",
                  backgroundColor: "#AD1C86",
                  mr: 2,
                  "&:hover": {
                    backgroundColor: "#065A79",
                  },
                }}
                aria-label="Chat with us on WhatsApp"
              >
                <WhatsApp sx={{ fontSize: { xs: "30px", md: "25px" } }} />
              </IconButton>

              {/* Instagram */}
              <IconButton
                href="https://www.instagram.com/shree_mangalam_academy/?igsh=MWVoZ3lrYWpnM3M2MQ%3D%3D#"
                target="_blank"
                sx={{
                  color: "#fff",
                  backgroundColor: "#AD1C86",
                  mr: 2,
                  "&:hover": {
                    backgroundColor: "#065A79",
                  },
                }}
                aria-label="Visit our Instagram page"
              >
                <Instagram sx={{ fontSize: { xs: "30px", md: "25px" } }} />
              </IconButton>

              {/* YouTube */}
              <IconButton
                href="https://www.youtube.com/@ShreemangalamSchool"
                target="_blank"
                sx={{
                  color: "#fff",
                  backgroundColor: "#AD1C86",
                  mr: 2,
                  "&:hover": {
                    backgroundColor: "#065A79",
                  },
                }}
                aria-label="Visit our YouTube channel"
              >
                <YouTube sx={{ fontSize: { xs: "30px", md: "25px" } }} />
              </IconButton>

              {/* Facebook */}
              <IconButton
                href="https://www.facebook.com/people/Shree-mangalam-School-Gudha-Gorji/100054859146008/?rdid=rEr04L3XDsCzRz83&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1GzR4NwdWd%2F%3Fref%3D1"
                target="_blank"
                sx={{
                  color: "#fff",
                  backgroundColor: "#AD1C86",
                  mr: 2,
                  "&:hover": {
                    backgroundColor: "#065A79",
                  },
                }}
                aria-label="Visit our Facebook page"
              >
                <Facebook sx={{ fontSize: { xs: "30px", md: "25px" } }} />
              </IconButton>

              {/* Twitter */}
              <IconButton
                href="https://x.com/shreemangalam11"
                target="_blank"
                sx={{
                  color: "#fff",
                  backgroundColor: "#AD1C86",
                  mr: 2,
                  "&:hover": {
                    backgroundColor: "#065A79",
                  },
                }}
                aria-label="Visit our Twitter page"
              >
                <Twitter sx={{ fontSize: { xs: "30px", md: "25px" } }} />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Footer Bottom Section */}
      <Box sx={{ mt: 4, textAlign: "center", mb: 4 }}>
        <Divider sx={{ my: 2, mb: 4, mt: 4, backgroundColor: "#fff" }} />
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            mt: 2,
            color: "#fff",
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
          }}
        >
          Copyright &copy; {currentYear} by Shree Mangalam School | All Rights
          Reserved.
        </Typography>
      </Box>

      {/* Scroll to Top Button */}
      {isVisible && (
        <IconButton
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            backgroundColor: "#AD1C86",
            color: "#fff",
            zIndex: 1000,
            "&:hover": {
              backgroundColor: "#065A79",
            },
          }}
        >
          <KeyboardArrowUpIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default Footer;
